import api from "../config/api";

import { ServiceReturn } from "../types/ServiceResponse";

import { Settings } from "../models/Organization";

const moduleBaseUrl = "organization";

export const getSettings = async ( _payload?: unknown, token?: string ): Promise<ServiceReturn<Settings>> => {
  try {
    const url = `/${ moduleBaseUrl }/settings`;
    const {
      data
    } = await api.get( url, {
      headers: {
        Authorization: `Bearer ${ token }`,
      },
    });

    return data;
  } catch ( error: any ) {
    return {
      data: false,
      message: error?.response?.data?.message ?? error?.message,
    };
  }
};
